import React from "react";
import Manager from "../../src/manager";
import Functions from "../../src/functions";

function Mapper(data, status, response, error, component) {
  let output = [];
  let UserType = Functions["custom"]["getUserType"]();
  if (
      UserType === "POSTB" ||
      UserType === "POSTB_SPLIT" ||
      UserType === "POSTR"
  ) {
    data = data.item;
  }else{
    data = data[0].item;
  }
  if (data) {
    let property = {};
    if (
      UserType === "POSTB" ||
      UserType === "POSTB_SPLIT" ||
      UserType === "POSTR"
    ) {
      property["lastUpdateDate"] = data.lastUpdateDate;
      property["showInfo"] = data.totalRemainingMB;
      property["balanceMBFormated"] = data.balanceMBFormated;
      property["totalOffPeakMB"] = data.totalOffPeakMB;
      property["totalOffPeakMeasUnitDisplay"] =
        data.totalOffPeakMeasUnitDisplay;
      property["totalRemainingDataDisplay"] = data.totalRemainingDataDisplay;
      property["totalRemainingDataMeasUnitDisplay"] =
        data.totalRemainingDataMeasUnitDisplay;
      property["totalRemainingMB"] = data.totalRemainingMB;
      property["unlimitedData"] = data.unlimitedData;
      property["items"] = data.items;
      property["mbInfoList"] = data.mbInfoList;
      sessionStorage.setItem(
        "totalRemainingMB",
        JSON.stringify(data.totalRemainingMB)
      );
    } else {
      property["balanceExpirationFormated"] = data.balanceExpirationFormated;
      property["showInfo"] = data.balance;
      property["balance"] = data.balance;
      property["totalDataBalance"] = data.totalDataBalance;
      property["availableMBsLastUpdateDateFormated"] =
        data.availableMBsLastUpdateDateFormated;
      property["totalDataBalanceFormated"] = data.totalDataBalanceFormated;
      property["totalDataBalanceMeasureUnitFormated"] =
        data.totalDataBalanceMeasureUnitFormated;
      property["balanceFormated"] = data.balanceFormated;
      property["allData"] = data;
      sessionStorage.setItem(
        "totalDataBalance",
        JSON.stringify(data.totalDataBalance)
      );
      sessionStorage.setItem(
        "listOfDataBuckets",
        JSON.stringify(data.listOfDataBuckets)
      );
      sessionStorage.setItem(
        "unlimitedDataPrepaidNinja",
        JSON.stringify(data.listOfUnlimitedDataPrepaidNinja)
      );
    }
    sessionStorage.setItem("balanceFormated", data.balanceFormated);
    output.push(property);
  }

  return output;
}

function Properties(args) {
  let editable = args.editable ? true : false;
  return {
    lastUpdateDate: {
      alias: "lastUpdateDate",
      type: "text",
      editable,
    },
    balanceMBFormated: {
      alias: "balanceMBFormated",
      type: "text",
      editable,
    },
    allData: {
      alias: "allData",
      type: "hidden",
    },
    balanceFormated: {
      alias: "balanceFormated",
      type: "text",
      editable,
    },
    totalDataBalanceMeasureUnitFormated: {
      alias: "totalDataBalanceMeasureUnitFormated",
      type: "text",
      editable,
    },
    availableMBsLastUpdateDateFormated: {
      alias: "availableMBsLastUpdateDateFormated",
      type: "text",
      editable,
    },
    totalDataBalance: {
      alias: "totalDataBalance",
      type: "text",
      editable,
    },
    balanceExpirationFormated: {
      alias: "balanceExpirationFormated",
      type: "text",
      editable,
    },
    totalDataBalanceFormated: {
      alias: "totalDataBalanceFormated",
      type: "text",
      editable,
    },
    mbInfoList: {
      alias: "mbInfoList",
      type: "text",
      editable,
    },
    totalOffPeakMB: {
      alias: "totalOffPeakMB",
      type: "number",
      editable,
    },
    totalOffPeakMeasUnitDisplay: {
      alias: "totalOffPeakMeasUnitDisplay",
      type: "text",
      editable,
    },
    totalRemainingDataDisplay: {
      alias: "totalRemainingDataDisplay",
      type: "text",
      editable,
    },
    totalRemainingDataMeasUnitDisplay: {
      alias: "totalRemainingDataMeasUnitDisplay",
      type: "text",
      editable,
    },
    totalRemainingMB: {
      alias: "totalRemainingMB",
      type: "number",
      editable,
    },
    unlimitedData: {
      alias: "unlimitedData",
      type: "boolean",
      editable,
    },
    items: {
      alias: "items",
      type: "text",
      editable,
    },
    showInfo: {
      alias: "showInfo",
      type: "text",
      label: "",
      placeholder: "",
      useCustomUI: true,
      customUI: function () {
        let data = this.props.data;
        let _this = this;
        let landPageData = JSON.parse(sessionStorage.landPageData);
        let UserType = Functions["custom"]["getUserType"]();
        return (
          <div>
            {UserType === "POSTB" ||
            UserType === "POSTB_SPLIT" ||
            UserType === "POSTR" ? (
              <div>
                {landPageData.contractInfoCarrier.hasBuiltInMB === false &&
                data.mbInfoList.length === 0 ? (
                  <a
                    className="view-statistics open-lightbox"
                    id="statisticsLink"
                    style={{cursor: 'pointer'}}
                  >
                    <span>Αναλυτικά</span>
                  </a>
                ) : (
                  <a
                    className="view-statistics open-lightbox"
                    id="statisticsLink"
                    style={{cursor: 'pointer'}}
                    onClick={(e) => clickMe(_this)}
                  >
                    <span>Αναλυτικά</span>
                  </a>
                )}
              </div>
            ) : (
              <>
                {data.allData.totalDataBalance === 0 &&
                data.allData.listOfDataBuckets.length === 0 ? (
                  <a
                    className="view-statistics open-lightbox"
                    id="statisticsLink"
                    style={{cursor: 'pointer'}}
                  >
                    <span>Αναλυτικά</span>
                  </a>
                ) : (
                  <a
                    className="view-statistics open-lightbox"
                    id="statisticsLink"
                    style={{cursor: 'pointer'}}
                    onClick={(e) => {
                      clickMe(_this);
                    }}
                  >
                    <span>Αναλυτικά</span>
                  </a>
                )}
              </>
            )}
          </div>
        );
      },
    },
  };
}

function clickMe(_this) {
  let id = _this.props.primaryKey;
  let manager = _this.props.manager;
  window["modal"].setState({
    // title: <h4>Confirm deletion</h4>,
    targetComponent: this,
    show: true,
    callback: function (args) {
      window["modal"].setState({ show: false });
      setTimeout(manager.refresh, 2000);
    },
    // footer: [],
    body: (
      <Manager
        module="infoPopUp"
        inputData={[_this.props.data]}
        view="list"
        ref={(refComponent) => {
          window["modalbody"] = refComponent;
        }}
      ></Manager>
    ),
  });
}

const InfoPanel = {
  auth: "",
  views: {
    list: {
      apis: {
        view: {
          url: "{path}",
          method: "POST",
          replace: {
            path: function () {
              let random = new Date().getTime();

              let landPageData = JSON.parse(sessionStorage.landPageData);

              if (
                landPageData.contractInfoCarrier.customerSegment === "POSTB" ||
                landPageData.contractInfoCarrier.customerSegment ===
                  "POSTB_SPLIT" ||
                landPageData.contractInfoCarrier.customerSegment === "POSTR"
              ) {
                return "/service/getAvailableMB?t=".concat(random);
              } else {
                return "/service/getCustomerData?t=".concat(random);
              }
            },
          },
          mapper: Mapper,
        },
      },
      template: "infoPanel",
      templateConfiguration: {
        includeProperties: [],
        excludeProperties: [],
        events: { onClick: function (e) {} },
      },
      properties: Properties({ editable: false }),
      primaryKey: "id",
    },
  },
};

export default InfoPanel;
